// Recovers from a failed lazy-chunk import (a stale hashed filename after a
// deploy) by prompting the user to reload onto the target route.
// See https://vite.dev/guide/build#load-error-handling

import i18n from '@/plugins/i18n.js';
import snackbarService from '@/services/SnackbarService.js';

const CHUNK_LOAD_ERROR_PATTERNS = [
    /Failed to fetch dynamically imported module/i,
    /error loading dynamically imported module/i,
    /Importing a module script failed/i,
    /Unable to preload CSS/i,
];

let activeToast = null;
let handlerRegistered = false;

export function isChunkLoadError(error) {
    const message = typeof error === 'string' ? error : (error?.message ?? '');

    return CHUNK_LOAD_ERROR_PATTERNS.some(pattern => pattern.test(message));
}

function promptReload(targetPath) {
    activeToast?.close();

    activeToast = snackbarService.open({
        type: 'is-success',
        message: i18n.global.t('new_version'),
        position: 'is-bottom-left',
        actionText: i18n.global.t('reload'),
        indefinite: true,
        onAction: () => window.location.assign(targetPath),
    });
}

export function registerChunkLoadErrorHandler(router) {
    if (handlerRegistered) {
        return;
    }

    handlerRegistered = true;

    router.onError((error, to) => {
        if (isChunkLoadError(error) && to?.fullPath) {
            promptReload(to.fullPath);

            return;
        }

        console.error(error);
    });

    router.afterEach(() => {
        activeToast?.close();
        activeToast = null;
    });
}
